export default "__VITE_ASSET__Bt0$WJo___"